import React from "react";
import Colors from "../../colors";
import { View } from "react-native";

const Badge = ({ children }) => {
    return (<View style={ownStyles.badge}>
        {children}
    </View>);
};

const ownStyles = {
    badge: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: Colors.primary,
        borderRadius: 8,
        fontSize: 10,
        paddingHorizontal: 4,
        paddingVertical: 2,
        color: Colors.onPrimary,
    },
};

export default Badge;